export default __webpack_public_path__ + "16a589289bbb86cbd0ea801eb77891b9.svg";